import React from "react";
import "./BrowseButton.css";
const BrowseButton = ({getQuestions, disabled}) => {
  return (
    <button className="frame"
    onClick={getQuestions}
    disabled={disabled}>
      <div className="div-wrapper">
        <div className="text-wrapper">Browse</div>
      </div>
    </button>
  );
};

export default BrowseButton;
